module.exports = __webpack_public_path__ + "static/media/beta-linear-line-dark.0bbb8044.svg";